function updateObject(state, action, actionType) {
  switch (action.type) {
    case actionType:
      return Object.assign({}, state, {
        items: action.items
      });
    default:
      return state;
  }
}

export const registrationStage = (state = [], action) => {
  return updateObject(state, action, 'REGISTRATION_STAGE')
}

export const registrationUpdatedStage = (state = [], action) => {
  return updateObject(state, action, 'REGISTRATION_UPDATED_STAGE')
}

export const clientRegistrationRestriction = (state = [], action) => {
  return updateObject(state, action, 'CLIENT_REGISTRATION_RESTRICTION')
}

export const clientRegistration = (state = [], action) => {
  return updateObject(state, action, 'CLIENT_REGISTRATION')
}

export const clientRegistrationPost = (state = [], action) => {
  return updateObject(state, action, 'CLIENT_REGISTRATION_POST')
}

export const clientInfo = (state = [], action) => {
  return updateObject(state, action, 'CLIENT_INFO')
}

export const clientDetails = (state = [], action) => {
  return updateObject(state, action, 'CLIENT_DETAILS')
}

export const partnerProperties = (state = [], action) => {
  return updateObject(state, action, 'PARTNER_PROPERTIES')
}